var _rect, _ellipse, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevicesIcon = function SvgDevicesIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 33,
    rx: 9.5,
    ry: 2,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.0406 14.19L21.0006 19.42L11.9606 14.19C12.3606 13.45 12.9406 12.8 13.5906 12.44L18.9306 9.48C20.0706 8.84 21.9306 8.84 23.0706 9.48L28.4106 12.44C29.0606 12.8 29.6406 13.45 30.0406 14.19Z",
    fill: "#2962FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.0006 19.4195V28.9995C20.2506 28.9995 19.5006 28.8395 18.9306 28.5195L13.5906 25.5595C12.3806 24.8895 11.3906 23.2095 11.3906 21.8295V16.1695C11.3906 15.5295 11.6106 14.8295 11.9606 14.1895L21.0006 19.4195Z",
    fill: "#2962FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6106 16.1695V21.8295C30.6106 23.2095 29.6206 24.8895 28.4106 25.5595L23.0706 28.5195C22.5006 28.8395 21.7506 28.9995 21.0006 28.9995V19.4195L30.0406 14.1895C30.3906 14.8295 30.6106 15.5295 30.6106 16.1695Z",
    fill: "#2962FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevicesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "devices-icon.d936a4c2f954306f60928abecac2060b.svg";